import type { AppType } from '@studio/backend';
import { hc } from 'hono/client';

export type StudioClient = ReturnType<typeof hc<AppType>>;

export interface ClientOptions {
  /** Origin of the backend, e.g. `https://api.aiproductstudio.app` or `http://localhost:8080`. */
  baseUrl: string;
  /**
   * Per-request fetch override. Frontend code typically wraps this to attach
   * the Clerk session token and `credentials: 'include'`.
   */
  fetch?: typeof fetch;
  /** Headers to merge onto every request. */
  headers?: () => Record<string, string>;
}

/**
 * Creates a typed Hono RPC client. All routes defined on the backend's
 * `AppType` flow through; e.g. `client.api.health.$get()` and
 * `client.api.me.$get()` are typed end-to-end.
 *
 * The client is stateless — create one per consumer (or memoize at the
 * provider boundary). Use `<StudioClientProvider client={...}>` from
 * `./context` for the React-friendly singleton pattern.
 */
export function createClient(options: ClientOptions): StudioClient {
  return hc<AppType>(options.baseUrl, {
    headers: options.headers,
    fetch: options.fetch,
  });
}
